<template>
  <div
    class="image-walll w-full border-solid border-1px rounded-10px border-[#EBEBEB] h-full p-10px py-5px bg-hex-$contentBgColor"
  >
    <column-header
      v-show="data.showTitle"
      class="mb-10px"
      :title="title"
      :showMore="data.showMore"
      @loadMore="loadMore"
    />
    <div :class="getBodyClass()" class="flex flex-col scroll-y">
      <div v-if="list.length" ref="listRef" class="pt-8px">
        <div
          v-for="n in row"
          :key="n"
          class="flex"
          :class="{
            'mt-8px': n !== 1,
          }"
        >
          <div
            v-for="item in col"
            :key="item"
            :class="{
              'mr-15px': item !== col,
            }"
            :style="{
              width: `calc((100% - ${15 * (col - 1)}px) / ${col})`,
            }"
          >
            <template v-if="list[col * (n - 1) + item - 1]">
              <div class="h-full w-full" @click="toDetail(list[col * (n - 1) + item - 1])">
                <div
                  class="relative w-full flex"
                  :style="{
                    marginRight: '12px',
                    paddingBottom: '5px',
                    borderBottom: n < list.length ? '1px dashed #ccc' : 'none',
                  }"
                >
                  <div class="relative flex">
                    <el-image
                      class="h-full cursor-pointer rounded-10px"
                      :src="`${fileUrl}${list[col * (n - 1) + item - 1].indexImage}`"
                      :fit="data.imageFit || 'fill'"
                      :style="{
                        width: '80px',
                        height: '60px',
                      }"
                    >
                      <div slot="error" class="image-slot"></div>
                    </el-image>
                    <img
                      src="../../assets/images/视频播放.png"
                      alt=""
                      class="absolute m-auto w-30px h-30px object-contain top-1/2 left-1/2"
                      style="transform: translateX(-50%) translateY(-50%)"
                    />
                  </div>
                  <div class="flex-1 flex flex-col justify-between ml-12px">
                    <p
                      :ref="`${col}+${n}`"
                      class="mt-8px text-15px text-hex-000 truncate hover:text-hex-$portalPrimaryColor w-full hideText"
                      :title="list[col * (n - 1) + item - 1].title"
                    >
                      {{ list[col * (n - 1) + item - 1].title }}
                    </p>
                    <div
                      class="mb-8px cursor-pointer text-hex-999 hover:text-hex-$portalPrimaryColor text-14px"
                      v-if="data.showDate"
                    >
                      <div class="truncate">
                        {{
                          dayjs(list[col * (n - 1) + item - 1].editPublishTime).format('YYYY/MM/DD')
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench'
import { informationPublishMap } from '@/modules/portal-management/js/config'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()
const columnHeader = () => {
  return import('./ColumnHeader')
}
const columnImageType = informationPublishMap.column.columnImgText // 图片栏目

export default {
  name: 'ImageNews',
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update', // update/view   update模式不触发点击
    },
    i: {
      type: String,
      default: '',
    },
  },
  components: {
    columnHeader,
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 1,
        totalCount: 0,
      },
      dataSource: '',
      list: [],
      title: '视频',
      source: 1,
      row: 1,
      col: 1,
    }
  },
  methods: {
    loadMore() {
      if (this.mode !== 'update') {
        this.$router.push({
          path: `/portal/homepage?columnId=${this.data.dataSource}`,
        })
      }
    },
    tableCurrentChange(value) {
      this.page.pageNo = value
      this.getListData()
    },
    getBodyClass() {
      if (this.data.showTitle) {
        return 'h-[calc(100%-41px)]'
      }
      return 'h-full'
    },
    changeLayout() {
      this.$nextTick(() => {
        const commonHeader = document.querySelector('#commonHeader')
        const height = this.$refs.listRef.offsetHeight + commonHeader.offsetHeight
        console.log('height', height, this.$refs.listRef.offsetHeight, commonHeader.offsetHeight)
        this.$emit('changeLayout', {
          height,
          i: this.i,
        })
      })
    },
    toDetail(item) {
      if (this.mode === 'view') {
        if (item.externalLink) {
          window.open(item.externalLink)
        } else {
          this.$router.push({
            path: '/portal/ColumnDetail',
            query: {
              id: item.id,
              type: columnImageType,
            },
          })
        }
      }
    },
    async getListData() {
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getVideoColumnTable(this.page.pageNo, this.page.pageSize, {
          columnId: this.data.dataSource,
          isShow: true,
        })
      })
      if (!err) {
        this.list = res.items
        this.page.totalCount = res.totalCount
        this.changeLayout()
      }
    },
    async getTitle() {
      if (this.data.title && this.data.dataSource) {
        this.getListData()
        return
      }
      if (this.data.dataSource !== '' && this.data.dataSource != null) {
        const [err, res] = await columApi.getColumnDetail(this.data.dataSource)
        if (!err) {
          this.title = res.name
          this.source = res.source
          this.getListData()
        }
      }
    },
  },
  created() {
    this.getTitle()
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.row = val.row || 1
          this.col = val.col || 1
          this.title = val.title || '视频'
          if (val.dataSource !== this.dataSource || this.col * this.row !== this.page.pageSize) {
            this.dataSource = this.data.dataSource
            this.page.pageSize = this.col * this.row
            this.getTitle()
          }
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.image-walll {
  &::v-deep .el-carousel {
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__arrow {
      width: 30px;
      height: 40px;
      border-radius: unset;
      background-color: rgba(0, 0, 0, 0.3);
      &:hover {
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
    .el-carousel__arrow--left {
      left: 0;
    }
    .el-carousel__arrow--right {
      right: 0;
    }
  }
  .hideText {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
  }
  .scroll-y {
    overflow-y: scroll;
  }
  .scroll-y::-webkit-scrollbar {
    height: 0 !important;
    width: 0 !important;
    background-color: transparent;
    border: none;
  }
}
</style>
